var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _vm.game_show_type == 1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        filterable: "",
                        clearable: "",
                        placeholder: _vm.$t("pleaseSelectDeliveryPackage")
                      },
                      on: { change: _vm.pkgChange },
                      model: {
                        value: _vm.searchData.pkg,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "pkg", $$v)
                        },
                        expression: "searchData.pkg"
                      }
                    },
                    _vm._l(_vm.searchpkgs, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.pkg_name, value: item.pkg_mark }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("selectAdChannel")
                  },
                  on: { change: _vm.advChannelchange },
                  model: {
                    value: _vm.searchData.ad_channel,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "ad_channel", $$v)
                    },
                    expression: "searchData.ad_channel"
                  }
                },
                _vm._l(_vm.advchannels, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.adv_platform_name,
                      value: item.adv_platform_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("selectAdPlacement")
                  },
                  model: {
                    value: _vm.searchData.ad_placement,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "ad_placement", $$v)
                    },
                    expression: "searchData.ad_placement"
                  }
                },
                _vm._l(_vm.advLocation, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.adv_place_name,
                      value: item.adv_place_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-date-picker", {
                staticClass: "data-sty",
                attrs: {
                  clearable: false,
                  "picker-options": _vm.pickerOptionsRadius,
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": _vm.$t("range"),
                  "start-placeholder": _vm.$t("startDate"),
                  "end-placeholder": _vm.$t("endDate")
                },
                model: {
                  value: _vm.value2,
                  callback: function($$v) {
                    _vm.value2 = $$v
                  },
                  expression: "value2"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.searchClick } },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { "max-height": "500", data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: _vm.$t("idLabel"), width: "60" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "game",
              label: _vm.$t("game"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "platform",
              label: _vm.$t("platform"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "channel",
              label: _vm.$t("channel"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pkg",
              label: _vm.$t("pkg"),
              "min-show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ad_channel",
              label: _vm.$t("adChannel"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ad_placement",
              label: _vm.$t("adPlacement"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "date",
              label: _vm.$t("date"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "register_date",
              label: _vm.$t("accountRegistrationTime"),
              "min-show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "reward_ad_times",
              label: _vm.$t("rewardAdTimes"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "banner_ad_times",
              label: _vm.$t("bannerAdTimes"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "inter_ad_times",
              label: _vm.$t("interstitialAdTimes"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "reward_ad_num",
              label: _vm.$t("rewardAdNum"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "banner_ad_num",
              label: _vm.$t("bannerAdNum"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "inter_ad_num",
              label: _vm.$t("interstitialAdNum"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "reward_ad_revenue",
              label: _vm.$t("rewardAdRevenue"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "banner_ad_revenue",
              label: _vm.$t("bannerAdRevenue"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "inter_ad_revenue",
              label: _vm.$t("interstitialAdRevenue"),
              "show-overflow-tooltip": "",
              "min-width": "150"
            }
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total, prev, pager, next",
          "current-page": _vm.searchData.page,
          total: _vm.total,
          "page-size": 10
        },
        on: { "current-change": _vm.handleCurrentChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }